import { motion } from "framer-motion";
import { ShieldCheck, KeyRound, EyeOff, Undo2 } from "lucide-react";

const POINTS = [
  { icon: KeyRound, title: "You authorize, explicitly", body: "Integrations with Google Gmail, Calendar and Contacts only work after you grant permission through Google's secure OAuth consent flow." },
  { icon: EyeOff, title: "Scoped access only", body: "GoDiGo requests only the specific scopes it needs to do its job. It never has unrestricted access to your Google account." },
  { icon: Undo2, title: "Revoke anytime", body: "Disconnect any integration from within the app or your Google account settings — instantly, at any time." },
];

export default function Privacy() {
  return (
    <section id="privacy" className="bg-[#F0F5F2] py-20 lg:py-32" data-testid="privacy-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-start gap-14 lg:grid-cols-[0.9fr_1.1fr]">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <p className="overline-label">Privacy & Security</p>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
              Your data. <span className="font-serif-accent italic text-[#2E7D5B]">Your rules.</span>
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-slate-600">
              GoDiGo takes your data and permissions seriously. Everything is built around consent, transparency and the minimum access required — nothing more.
            </p>
            <div className="mt-8 inline-flex items-center gap-3 rounded-2xl border border-emerald-200 bg-white px-5 py-4">
              <ShieldCheck size={22} className="text-emerald-700" />
              <span className="text-sm font-semibold text-slate-800">Permission-based by design. Always.</span>
            </div>
          </motion.div>

          <div className="flex flex-col gap-4">
            {POINTS.map((p, i) => (
              <motion.div
                key={p.title}
                data-testid={`privacy-point-${i + 1}`}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                className="flex gap-5 rounded-3xl border border-slate-200 bg-white p-7"
              >
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#1B4D3E] text-lime-300">
                  <p.icon size={20} />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-bold text-slate-900">{p.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{p.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
